/**
 * Shared tabs component. Will render tabs, and set the current tab based on state variables.
 **/

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Tabs({ tabs, setCurrentTab, currentTab }) {
  // TODO: Assert that tabs has a specific structure here.
  return (
    <div>
      <div className="hidden sm:block">
        <nav className="flex space-x-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <a
              key={tab.name}
              href={tab.href}
              className={classNames(
                tab.name === currentTab ? 'bg-gray-200 text-gray-800' : 'text-gray-600 hover:text-gray-800',
                'rounded-md px-3 py-2 text-sm font-medium'
              )}
              onClick={() => setCurrentTab(tab.name)}
              aria-current={tab.name === currentTab ? 'page' : undefined}
            >
              {tab.name}
            </a>
          ))}
        </nav>
      </div>
    </div>
  )
}
